// extracted by mini-css-extract-plugin
export var container = "styles-module--container--c281e";
export var wide = "styles-module--wide--8eed5";